import React from 'react';
import { AlertTriangle } from 'lucide-react';
import BetaFeedbackModal from '../components/shared/BetaFeedbackModal';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    console.error("Fatal exception caught by ErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-slate-950 flex flex-col items-center justify-center p-6 text-center animate-fade-in relative overflow-hidden">
          <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_50%_50%,_rgba(239,68,68,0.5)_0%,_transparent_50%)] pointer-events-none"></div>
          
          <div className="bg-slate-900 border border-slate-800 p-10 rounded-3xl shadow-2xl max-w-lg w-full relative z-10">
            <div className="w-20 h-20 bg-red-500/20 rounded-full mx-auto flex items-center justify-center mb-6 border border-red-500/30">
               <AlertTriangle size={40} className="text-red-500 animate-pulse" />
            </div>
            <h1 className="text-2xl font-black text-white uppercase tracking-widest mb-3">
              System Anomaly Detected
            </h1>
            <p className="text-slate-400 mb-8 font-medium leading-relaxed">
              The telemetry node encountered a fatal exception. Please submit the crash report to reboot the environment.
            </p>
            
            {/* Inject the QA Loop Modal inline for autonomous crash recovery */}
            <BetaFeedbackModal 
              crashTrace={this.state.errorInfo?.componentStack || this.state.error?.toString()} 
              forceOpen={true} 
            />
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}